import angular from 'angular';
import $ from 'jquery';
import _ from 'lodash';
import template from './template.html';
import './style.scss';
import logger from '../../../shared/logger';
import UtilsService from '../../../services/utilsService';

export class RecruiterComponent {
    officeGroups = [];

    selectedOfficeGroup = 'OFFICE_USA';

    /* @ngInject */
    constructor(
        AuthService,
        RecruiterService,
        EmployerService,
        OfficeService,
        permissions,
        $cookies,
        $translate,
        RouteService,
        $state,
        $stateParams,
        Restangular,
        $timeout,
        WebAppRouteService,
    ) {
        const recruiterCtrl = this;
        const isTalenyaUser = permissions.isTalenyaUser();

        const groupVisibilityState = {};
        const employersPerOfficeLimitState = {};
        recruiterCtrl.employersPerOffice = {};
        recruiterCtrl.MAX_EMPLOYERS_TO_DISPLAY = RouteService.getSystemPreference('appMenuMaxEmployersPerOfficeQuantity') || 5;
        recruiterCtrl.employerNameSearchValue = '';

        recruiterCtrl.tftMainLogoUrl = RouteService.getThemeSettings('tftMainLogoUrl') || '';

        recruiterCtrl.setGroupVisibility = (group, isVisible) => {
            groupVisibilityState[group] = isVisible ?? !groupVisibilityState[group];
        };

        recruiterCtrl.closeAllEmployerOffices = () => {
            for (const office in recruiterCtrl.employersPerOffice) {
                recruiterCtrl.setGroupVisibility(office, false);
            }
        };

        recruiterCtrl.isGroupVisible = (group) => groupVisibilityState[group];

        recruiterCtrl.setEmployersPerOfficeLimitState = () => {
            for (const officeName in recruiterCtrl.employersPerOffice) {
                const employersQty = recruiterCtrl.employersPerOffice[officeName].length;
                employersPerOfficeLimitState[officeName] = employersQty > recruiterCtrl.MAX_EMPLOYERS_TO_DISPLAY;
            }
        };

        recruiterCtrl.isGroupLimited = (office) => employersPerOfficeLimitState[office];

        recruiterCtrl.toggleLimitState = (office) => {
            employersPerOfficeLimitState[office] = !employersPerOfficeLimitState[office];
        };

        recruiterCtrl.clearEmployerNameSearch = () => {
            recruiterCtrl.employerNameSearchValue = '';
            recruiterCtrl.employersFilteredByName = recruiterCtrl.employers;
            recruiterCtrl.employersPerOffice = recruiterCtrl.getEmployersPerOffice(recruiterCtrl.employers);
            recruiterCtrl.setEmployersPerOfficeLimitState();
            recruiterCtrl.closeAllEmployerOffices();
        };

        recruiterCtrl.getEmployersPerOffice = (employers) => _.reduce(employers, (acc, employer) => {
            const officeName = employer.office;
            acc[officeName] = acc[officeName] ? [...acc[officeName], employer] : [employer];
            return acc;
        }, {});

        UtilsService.cookiesOverride($cookies);

        const userPrefs = UtilsService.parseJSON($cookies.get('userprefs'));
        const userData = UtilsService.parseJSON($cookies.get('userData'));

        recruiterCtrl.init = (async () => {
            UtilsService.cookiesOverride($cookies);
            const isUserAuthenticated = $cookies.get('authResult');

            if (!isUserAuthenticated) {
                AuthService.logout();
            }

            try {
                const { result } = await OfficeService.getOffices() || {};
                this.officeGroups = result || [];
                this.officeGroups.forEach((group) => groupVisibilityState[group] = !isTalenyaUser);
            } catch (error) {
                logger.error(error);
            }

            if (userPrefs && $stateParams.recruiterId !== userPrefs?.entityId) {
                Restangular.setDefaultHeaders({
                    'on-behalf': JSON.stringify({ recruiterId: $stateParams.recruiterId }),
                });
            }

            recruiterCtrl.searchData = {
                type: 'recruiter',
                entityId: $stateParams.recruiterId,
            };
        })();

        recruiterCtrl.toggleMenu = function () {
            $('.background')
                .toggle();
            $('.navbar-nav-menu')
                .toggle();
            recruiterCtrl.showMenu = !recruiterCtrl.showMenu;

            if (!recruiterCtrl.showMenu) {
                recruiterCtrl.clearEmployerNameSearch();
            }
        };

        recruiterCtrl.closeMenu = function () {
            if (recruiterCtrl.showMenu) {
                recruiterCtrl.toggleMenu();
            }
        };

        if (isTalenyaUser) {
            recruiterCtrl.talenyaUser = true;
            RecruiterService.getAllRecruitersForMenu()
                .then((response) => {
                    recruiterCtrl.recruiters = response.result;
                    recruiterCtrl.currentUsers = _.remove(recruiterCtrl.recruiters, (recruiter) => {
                        if (userPrefs && userPrefs.entityId === recruiter._id) {
                            return true;
                        }
                        if (recruiter.contact) {
                            for (let i = 0; i < recruiter.contact.email.length; i++) {
                                const storedEmail = _.get(userData, 'email');

                                if (recruiter.contact.email[i].value === storedEmail) {
                                    return true;
                                }
                            }
                        }
                        return false;
                    });
                })
                .catch((err) => logger.error(err));
        }
        if (userData?.roles?.indexOf('AM') >= 0) {
            recruiterCtrl.accountManager = true;
        }

        recruiterCtrl.userPicture = RouteService.getUserData('picture');

        RecruiterService.getRecruiter($stateParams.recruiterId)
            .then((response) => {
                const { result: recruiterData } = response || {};
                if (recruiterData) {
                    recruiterCtrl.recruiterData = recruiterData;
                    if (isTalenyaUser) {
                        EmployerService.getAllEmployersForMenu()
                            .then(({ result: employers }) => {
                                recruiterCtrl.employers = _.orderBy(employers, ['settings.isResellerPartner', 'name'], ['desc', 'asc']);
                                recruiterCtrl.employersFilteredByName = employers;
                                recruiterCtrl.employersPerOffice = recruiterCtrl.getEmployersPerOffice(recruiterCtrl.employers);
                                recruiterCtrl.clearEmployerNameSearch();
                                recruiterCtrl.setEmployersPerOfficeLimitState();
                            });
                    } else {
                        const positionIds = _.chain(recruiterCtrl)
                            .get('recruiterData.positions', [])
                            .filter({ status: 'Active' })
                            .map('positionId')
                            .value();
                        if (positionIds.length > 0) {
                            EmployerService.getEmployersByPositionIds({ positionIDs: positionIds })
                                .then(({ result: employers }) => {
                                    recruiterCtrl.employers = _.orderBy(employers, ['settings.isResellerPartner', 'name'], ['desc', 'asc']);
                                    recruiterCtrl.employersPerOffice = recruiterCtrl.getEmployersPerOffice(recruiterCtrl.employers);
                                    recruiterCtrl.setEmployersPerOfficeLimitState();
                                })
                                .catch((err) => logger.error(err));
                        } else {
                            recruiterCtrl.employers = [];
                            recruiterCtrl.employersPerOffice = recruiterCtrl.getEmployersPerOffice(recruiterCtrl.employers);
                            recruiterCtrl.setEmployersPerOfficeLimitState();
                        }
                    }

                    $timeout(() => {
                        const { defaultOffice = this.selectedOfficeGroup } = this.recruiterData.geographicPreferences || {};
                        this.selectedOfficeGroup = defaultOffice;
                    });
                }
            })
            .catch((err) => logger.error(err));

        recruiterCtrl.refreshLists = function () {
            RouteService.getRefreshMetaData()
                .catch((err) => logger.error(err));
        };

        recruiterCtrl.onEmployerFilterChange = function () {
            recruiterCtrl.employersFilteredByName = recruiterCtrl.employers.filter(
                (e) => _.includes(_.toLower(e.name), _.toLower(recruiterCtrl.employerNameSearchValue)),
            );

            recruiterCtrl.employersPerOffice = recruiterCtrl.getEmployersPerOffice(recruiterCtrl.employersFilteredByName);
            recruiterCtrl.setEmployersPerOfficeLimitState();

            for (const group in groupVisibilityState) {
                groupVisibilityState[group] = !_.isEmpty(recruiterCtrl.employerNameSearchValue);
            }
        };

        recruiterCtrl.editRecruiter = function () {
            $state.go(
                'recruiter.editRecruiter',
                { recId: $stateParams.recruiterId },
            );
        };

        recruiterCtrl.logout = function () {
            AuthService.logout();
        };

        recruiterCtrl.goToCreateCand = function () {
            $('.background')
                .toggle();
            $('.navbar-nav-menu')
                .toggle();
            $state.go('recruiter.createNewCandidate');
        };

        recruiterCtrl.goPositionsPage = (employerId) => {
            WebAppRouteService.goPositionsPage({
                employerId,
            });
        };
    }
}

export const RecruiterComponentConfiguration = {
    template,
    controller: RecruiterComponent,
    controllerAs: 'recruiterCtrl',
};

angular
    .module('TALENYA-FE')
    .component('recruiterComponent', RecruiterComponentConfiguration);
